import React, { useState } from "react";
export const ProtocolContext = React.createContext(null);

export const ProtocolProvider = ({ children }) => {
  const [list, setList] = useState(null);
  const [days, setDays] = useState(null);
  const [maxDay, setMaxDay] = useState(null);
  const [numWeeks, setNumWeeks] = useState(null);

  const saveList = (list) => {
    setList(list);
  };

  const removeList = () => {
    setList(null);
  };

  const saveDays = (day) => {
    setDays(day);
  };

  const removeDays = () => {
    setDays(null);
  };

  const saveNumWeeks = (num) => {
    setNumWeeks(num);
  };

  const removeNumWeeks = () => {
    setNumWeeks(null);
  };

  const saveMaxDay = (day) => {
    setMaxDay(day);
  };

  const removeMaxDay = () => {
    setMaxDay(null);
  };

  return (
    <ProtocolContext.Provider
      value={{
        list,
        saveList,
        removeList,
        days,
        saveDays,
        removeDays,
        numWeeks,
        saveNumWeeks,
        removeNumWeeks,
        maxDay,
        saveMaxDay,
        removeMaxDay,
      }}
    >
      {children}
    </ProtocolContext.Provider>
  );
};
